import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  PresalePlacePage,
  presaleCampaignSearchSchema,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleCampaignSearchSchema.shape,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/place")({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  return <PresalePlacePage search={Route.useSearch()} />;
}
